import { throttle } from 'lodash';
import { useLayoutEffect, useMemo, useRef } from 'react';

export const useWindowScroll = (handleScroll: (isScrollingUp: boolean) => void) => {
  const yPos = useRef(window.scrollY);

  const onScroll = useMemo(
    () =>
      throttle(() => {
        const currYPos = window.scrollY;
        const isCurrScrollingUp = currYPos === 0 ? false : yPos.current > currYPos;

        // FUTURE TODO: ideally we would save the prev value and only update when different...
        // however callers of useWindowScroll expect handleScroll to called continually as the page
        // scrolls so side effect code can be called... not ideal, but at least this reduces # of calls
        // -- it's probably best to trash this hook entirely long term though
        handleScroll(isCurrScrollingUp);

        yPos.current = currYPos;
      }, 100),
    [handleScroll]
  );

  useLayoutEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => {
      onScroll.cancel();
      window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);
};
